import React, { useEffect, useState, useContext } from 'react'
import PhoneInput from "react-phone-input-2";
import { useProcessor } from '../../hooks/useProcessor';
import { useShareFiado } from '../../hooks/useShareFiado';
import FInput from '../../components/FInput/FInput';
import { useFormik } from "formik";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import FInputt from '../../components/FInputt/FInputt';
import { v4 as uuidv4 } from 'uuid';
import { useContacts } from '../../hooks/useContacts';
import { concat, map } from 'lodash';
import { usePhoneFormat } from '../../hooks/usePhoneFormat';
import FInputText from '../../components/Finputs/FInputText/FInputText';
import Fbutton from '../../components/Finputs/FButton/Fbutton';
import FContainer from '../../components/FContainer/FContainer';
import Swal from 'sweetalert2';
import jwt_decode from "jwt-decode";
import { useHome } from "../Home/hooks/useHome";
import { useCurrencyFormat } from '../../hooks/useCurrencyFormat';
import FcardContact from '../../components/FcardContact/FcardContact';



export const ShareFiadoScreen = () => {
    const { saldo, textSaldo, _getBalance } = useHome();
    const { formatWithCurrencyISO } = useCurrencyFormat();

    const navigate = useNavigate();
    const { processPayment } = useProcessor();
    const [phone, setPhone] = useState('')
    const { setAlert } = useContext(AuthContext)
    const { isRegistered, setIsRegistered, identityInfo, setIdempotencyKey, setIdentityInfo, phoneNumber, setPhoneNumber, closeContact, idempotencyKey, getFirstDigits, getIdentify, getIdentity } = useShareFiado();
    const { getFavoriteContacts, favoriteContacts, getFirstLetter, aleatory3colors, getTwoWords } = useContacts();
    const [aleatory3colorss, setaleatory3colorss] = useState('')
    const tokennn = localStorage.getItem("token");
    const tokenDecode = jwt_decode(tokennn);



    useEffect(() => {
        _getBalance();
        formik.setFieldValue(
            "number",
            ""
        );
        setaleatory3colorss(aleatory3colors())
    }, []);


    const { validateLocalPhone } = usePhoneFormat()

    const route = useNavigate()
    const identify = async (phoneNumber) => {
        console.log()
        const next = () => {
            formik.setFieldValue("number", "");
            setIsRegistered(false);
            setIdentityInfo([]);
        }

        if (tokenDecode.phoneNumber == phoneNumber) {
            Swal.fire({
                showCloseButton: true,
                title: 'Atención',
                text: "No puedes compartirte a ti mismo ",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            }).then((result) => {
                if (result.isConfirmed) {
                    next()
                }
            });
        } else {
            const response = await getIdentify(phoneNumber);
            if (response === false) {
                Swal.fire({
                    showCloseButton: true,
                    title: 'Atención',
                    text: "Esta persona no se encuentra registrada en Fiado, pero al enviarle dinero se le generará un link para que se registre y así su dinero llegará a la cuenta.",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                })
            }
            setIdempotencyKey(uuidv4());
        }
    }

    const nextScreen = async (data, idempotencyKey) => {
        let response = await processPayment(data, idempotencyKey);
        if (response?.data?.code == "PROCESS_OK") {


            const next = () => {
                setIsRegistered(false);
                setIdentityInfo([]);
                setPhoneNumber('');
                navigate('/');
            }
            Swal.fire({
                showCloseButton: true,
                title: 'Éxito',
                text: "Se ha confirmado el pago exitosamente.",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                // iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            }).then((result) => {
                if (result.isConfirmed) {
                    next();
                } else {
                    next();
                }
            })
        }
    }



    const formik = useFormik({
        initialValues: {
            amount: 0,
            concept: '',
            saveAsFavorite: true,
            number: ""
        },
        onSubmit: (values) => {
            const { amount, concept, saveAsFavorite, number } = values;
            const monto = parseFloat(amount)
            const data = {
                originCurrencyId: "484",
                destinationCurrencyId: "484",
                exchangeRateId: '',
                products: [
                    {
                        id: "FIADO_FUNDS_AVAILABLE_MXN"
                    },
                    {
                        id: "FIADO_SHARE_MXN",
                        amount: monto,
                        beneficiaryDirectoryId: identityInfo?.directoryId,
                        typeOfDirectoryId: "USER",
                        concept: concept,
                        saveAsFavorite: saveAsFavorite
                    }
                ]
            }

            console.log(data)
            {
                (isRegistered === true)
                    ? nextScreen(data, idempotencyKey)
                    : route('/NotRegistredScreen', {
                        state: {
                            phoneNumber: values.number,
                            amount: monto,
                            concept: concept
                        }
                    });
            }
        },
        validate: (values) => {

            const errors = {};

            if (values.amount == 0) {
                errors.amount = "El monto debe ser mayor a 0";
            }


            if (values.concept == '') {
                errors.concept = "Ingresa el concepto.";
            }


            if (validateLocalPhone(values.number) == false && validateLocalPhone(phoneNumber) == false) {
                errors.number = "Ingresa un número de teléfono válido.";
            }

            return errors;
        },
    })


    const getIdentifyByNumber = (phoneNumber) => {

        if (getFirstDigits(phoneNumber) === '+1' && phoneNumber.length === 12) {
            console.log('usa')
            identify(phoneNumber);
        } else if ((getFirstDigits(phoneNumber) === '+52' || '+57') && phoneNumber.length === 13) {
            console.log('mexico')
            identify(phoneNumber);
        } else {

        }
    }



    useEffect(() => {
        getIdentifyByNumber(formik?.values.number);
    }, [formik?.values?.number])

    useEffect(() => {
        getFavoriteContacts();
    }, [])

    useEffect(() => {
        console.log(favoriteContacts)

    }, [[favoriteContacts]])

    return (
        <>
            <FContainer>
                {
                    isRegistered ? (<>
                        <FcardContact
                            backgroundInitial={aleatory3colorss}
                            className="!shadow-none !my-2"
                            preferredName={identityInfo.name}
                            onDeleteMembers={() => {
                                formik.setFieldValue(
                                    "number",
                                    ""
                                );
                                closeContact()
                            }}
                        />

                    </>)
                        : null
                }


                {isRegistered ? null : isRegistered ? (<>
                    <FInputText
                        title="¿A quién deseas enviar?"
                        type="PhoneInput"
                        value={formik.values.number}
                        disabled={isRegistered}
                        errorMessage={
                            formik.errors.paymentAccountNumber
                        }
                    />
                </>)
                    : <FInputText
                        title="¿A quién deseas enviar?"
                        type="PhoneInput"
                        value={formik.values.number}
                        disabled={isRegistered}
                        onChange={(value) => {
                            formik.setFieldValue(
                                "number",
                                value
                            );
                        }}
                        errorMessage={
                            formik.errors.paymentAccountNumber
                        }
                    />}

                <FInputText
                    type="CurrencyInput"
                    title={"Cantidad (MXN)"}
                    laceholder="¿Cuánto?"
                    value={formik.values.amount}
                    disabled={saldo == 0}
                    maxLength={10}
                    onChange={async (value) => {
                        formik.setFieldValue("amount", value == undefined ? 0 : value);
                    }}
                    errorMessage={saldo == 0 ? "No cuentas con saldo" :
                        formik.errors.amount
                    }
                />
                <FInputText title={"Concepto"} placeholder={"Concepto"} value={formik.values.concept} onChange={(value) => {
                    formik.setFieldValue(
                        "concept",
                        value
                    );
                }} />

                {favoriteContacts?.length > 0 ? (
                    <div className='mt-5 flex content-center  items-center  bg-stripes-sky text-center h-28 p-1 justify-start  overflow-y-hidden overflow-x-scroll' >
                        {
                            favoriteContacts?.length > 0 ?
                                favoriteContacts.map((contact, index) => (
                                    <div className='p-2 grid place-items-center' onClick={() => {
                                        formik.setFieldValue(
                                            "number",
                                            contact.phoneNumber
                                        );
                                        getIdentity(contact.phoneNumber)
                                    }}>

                                        <div>
                                            <div style={{ backgroundColor: aleatory3colorss }} className={`shadow-lg rounded-[12px] h-[60px] w-[60px] font-bold flex flex-col justify-center cursor-pointer`}>
                                                <div className='text-white text-xl'>{getFirstLetter(contact.preferedName)}</div>
                                            </div>
                                        </div>
                                        <div>{getTwoWords(contact.preferedName)}</div>
                                    </div>

                                )) : null
                        }

                    </div>) : null}


                <Fbutton
                    value={"Continuar"}
                    disabled={!formik.isValid}
                    onClick={formik.handleSubmit}
                />
                <div className='pt-5 text-Secondary font-bold text-[16px] cursor-pointer' onClick={() => {
                    route("/ShareGroupScreen")
                }}>
                    ¿Deseas enviar a varias personas al tiempo?
                </div>
            </FContainer>
        </>
    )
}
